/**
 * Client-side best-effort affordability check. `price` is the offer's
 * per-unit price the SAME way BottomAction already treats it — an amount
 * in the operator currency's major unit, no `exchangeRate` conversion
 * applied. `balanceCents === null` means the wallet hasn't loaded yet;
 * we let the caller through rather than block on missing data — the
 * backend stays the real authority and refunds atomically on rejection.
 */
export function canAffordOffer(
  price: string,
  quantity: number,
  balanceCents: number | null,
): boolean {
  if (balanceCents == null) return true;
  const totalCents = Math.round(Number(price) * 100) * quantity;
  return balanceCents >= totalCents;
}
